import React from 'react';
import HistoryTableHeader from './historyTableHeader';
import { WebViewerLicensesTableColumnCaptions } from './tableColumnCaptions';

const WebViewerLicenseHistoryTableHeader = (props) => {
  const { editedFields, objectData } = props;

  const title = [{
    title: WebViewerLicensesTableColumnCaptions.key,
    value: objectData ? objectData.key : '',
  }];

  return <HistoryTableHeader editedFields={editedFields} captions={WebViewerLicensesTableColumnCaptions} objectData={objectData} title={title}/>
};

export default WebViewerLicenseHistoryTableHeader;


// WEBPACK FOOTER //
// ./src/components/webViewerLicenseHistoryTableHeader.js